import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useNotification } from '../Contexts/NotificationContext';
import { useToken } from '../Contexts/TokenContext';

const ProtectedRoute = ({ element, admin = false }) => {
    const { setNotification } = useNotification();
    const { isAuthenticated, checkToken, tokenData, isFirstAccess } = useToken();
    const [fadeOut, setFadeOut] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const userType = localStorage.getItem('user_type');

    useEffect(() => {
        if (isAuthenticated === null) {
            checkToken();
        }
    }, [isAuthenticated, checkToken]);

    useEffect(() => {
        const timer = setTimeout(() => setFadeOut(true), 600);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (tokenData?.etapa_cadastro === 'etapa1') {
            navigate('/cadastro/finalizar-cadastro', { replace: true });
        } else if (tokenData?.etapa_cadastro === 'termos') {
            navigate('/cadastro/termos-de-uso', { replace: true });
        } else if (tokenData?.etapa_cadastro !== 'etapa1' && location.pathname === '/cadastro/finalizar-cadastro') {
            navigate('/painel', { replace: true });
        } else if (tokenData?.etapa_cadastro !== 'termos' && location.pathname === '/cadastro/termos-de-uso') {
            if (isFirstAccess) {
                setNotification({
                    type: 'success',
                    message: 'Seja bem vindo ao programa!',
                    show: true,
                });
                navigate('/painel');
            } else {
                navigate('/painel', { replace: true });
            }
        }
    }, [tokenData?.etapa_cadastro, location.pathname]);

    if (isAuthenticated === null) {
        return (
            <div
                className={`fixed left-0 top-0 z-[999999] flex h-screen w-screen items-center justify-center bg-white transition-opacity duration-300 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
            >
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-secondary border-t-transparent"></div>
            </div>
        );
    }

    if (isAuthenticated) {
        if (admin && userType !== 'administrador') {
            return <Navigate to="/" replace />;
        }

        if (!admin && userType !== 'interno') {
            return <Navigate to="/manager" replace />;
        }

        return element;
    }

    return (
        <Navigate
            to={admin ? '/manager/login' : '/login/'}
            state={{ from: location.pathname + location.search + location.hash }}
            replace
        />
    );
};

export default ProtectedRoute;
